module.exports = __webpack_public_path__ + "static/media/en.23d0a25b.svg";